module.exports = __webpack_public_path__ + "static/media/heritage.6b6798c1.svg";